import './QR.css';
import '../ref/QR.png';

const QR = () => {
    return (
        <div className="QRPage">
            <div className="QR-Container">
                <div className="QR-Header">
                    <h1 className="QR-Title">Scan to Connect</h1>
                    <p className="QR-Subtitle">Point your camera at the QR code</p>
                </div>
                
                <div className="QR-Image-Wrapper">
                    <div className="QR-Image-Border">
                        <img 
                            src={require('../ref/QR.png')} 
                            alt="QR Code" 
                            className="QR-Image"
                        />
                    </div>
                    <div className="QR-Corner QR-Corner-TL"></div>
                    <div className="QR-Corner QR-Corner-TR"></div>
                    <div className="QR-Corner QR-Corner-BL"></div>
                    <div className="QR-Corner QR-Corner-BR"></div>
                </div>

                <div className="QR-Instructions">
                    <p className="QR-Instruction-Text">
                        Open your camera app and point it at the code
                    </p>
                    <div className="QR-Divider"></div>
                    <p className="QR-Footer-Text">
                        Kyle Bostelman • Portfolio
                    </p>
                </div>
            </div>
        </div>
    );
};

export default QR;